// extracted by mini-css-extract-plugin
export default {"header":"CardExpandable_header__xr7oH","container":"CardExpandable_container__loX0b","wrapper":"CardExpandable_wrapper__Q0HLF"};